// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lileep: PokeData = {
  "id": 345,
  "name": "lileep",
  "height": 10,
  "weight": 238,
  "base_experience": 71,
  "types": [
    PokeType.ROCK,
    PokeType.GRASS
  ],
  "api_moves": [
    "wrap",
    "acid",
    "mega-drain",
    "confuse-ray",
    "constrict",
    "amnesia",
    "giga-drain",
    "ancient-power",
    "stockpile",
    "spit-up",
    "swallow",
    "ingrain",
    "astonish",
    "brine",
    "wring-out",
    "gastro-acid",
    "energy-ball"
  ],
  "moves": [
    "acid",
    "confuse-ray",
    "ancient-power",
    "brine",
    "energy-ball",
    "rock-slide",
    "stone-crush",
    "flower-rush",
    "solar-beam",
    "rock-blast",
    "boulder_bash",
    "power-whip",
    "grassy-terrain"
  ],
  "evolution_chain": {
    "id": 176,
    "item": null,
    "species": [
      {
        "name": "lileep",
        "order": 373,
        "types": [
          PokeType.ROCK,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cradily",
        "order": 374,
        "types": [
          PokeType.ROCK,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 345,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 74,
    "speed": 23,
    "ability_power": 61
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
